<template>
  <div class="form formLine">
    <el-form :model="formInfo.data"
             :inline="formInfo.inline"
             :rules="formInfo.rules"
             ref="form"
             :label-width="formInfo.labelWidth"
             style="text-align:left">
      <el-form-item v-for="item of formInfo.list"
                    v-show="item.shows?item.show:true"
                    :key="item.label"
                    :label="item.label"
                    :prop="item.value"
                    :label-width="item.labelWidth?item.labelWidth:''"
                    :class="item.className">
        <template slot="label">
          <span style="position:relative">
              <span>{{item.label}}</span>
              <el-tooltip style="position:absolute;right:-8px;" class="item" effect="dark" placement="top" v-if="item.labelContent">
                <div slot="content">
                  <p>{{item.labelContent}}</p>
                </div>
                <i class="el-icon-info table-msg" />
            </el-tooltip>
          </span>
        </template>
        <el-input v-if="item.type=='text'"
                  v-model="formInfo.data[item.value]"
                  type="text"
                  :remote="item.remote"
                  :remote-method="item.remote?remoteMethod:none"
                  @change="selectChangeTtext"
                  :disabled="item.disabled"
                  :placeholder="item.placeholder?item.placeholder:('请输入'+item.label.slice(0,item.label.length-1))"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @focus="item.event?hanClick(item.event,item.value):null"
                  @keyup.enter.native="hanClick('sub')">
          <template slot="prefix" v-if="item.prefix">
            <i class="el-icon-search select_header" :size="item.size?item.size:'small'" @click.stop="selectHeaderClick(item.label)"></i>
          </template>
        </el-input>
        <!-- textSH税号 -->
        <el-input v-if="item.type=='textSH'"
                  v-model="formInfo.data[item.value]"
                  type="text"
                  oninput="value=value.replace(/[^a-zA-Z0-9]/g, '')"
                  :disabled="item.disabled"
                  :placeholder="item.placeholder?item.placeholder:('请输入'+item.label.slice(0,item.label.length-1))"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @focus="item.event?hanClick(item.event):null"
                  @input="item.input?hanClick(item.input):null"
                  @keyup.enter.native="hanClick('sub')"
                  @change="selectChange">
            <i slot="suffix" v-if="item.append" class="el-input__icon el-icon-copy-document" @click="appendClick(item.value)"></i>
          <template slot="prefix" v-if="item.prefix">
            <i class="el-icon-search select_header" :size="item.size?item.size:'small'" @click.stop="selectHeaderClick(item.label)"></i>
          </template>
        </el-input>
        <el-input v-if="item.type=='number'"
                  v-model="formInfo.data[item.value]"
                  type="text"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  :remote="item.remote"
                  :maxlength="11"
                  :remote-method="item.remote?remoteMethod:none"
                  @change="selectChangeTtext"
                  :disabled="item.disabled"
                  :placeholder="item.placeholder?item.placeholder:('请输入'+item.label.slice(0,item.label.length-1))"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @input="item.input?hanClick(formInfo.data[item.value]):null"
                  @focus="item.event?hanClick(item.event,item.value):null"
                  @keyup.enter.native="hanClick('sub')">
        </el-input>
        <el-input v-if="item.type=='numberPhone'"
                  v-model="formInfo.data[item.value]"
                  type="text"
                  oninput="value=value.replace(/[^\-\d]/g,'')"
                  :remote="item.remote"
                  :maxlength="11"
                  :remote-method="item.remote?remoteMethod:none"
                  @change="selectChangeTtext"
                  :disabled="item.disabled"
                  :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @input="item.input?hanClick(item.input):null"
                  @focus="item.event?hanClick(item.event,item.value):null"
                  @keyup.enter.native="hanClick('sub')">
        </el-input>
        <!--  v-thousands千位分隔符 -->
        <el-input v-if="item.type=='float'"
                  v-model="formInfo.data[item.value]"
                  type="text"
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  :remote="item.remote"
                  :remote-method="item.remote?remoteMethod:none"
                  :disabled="item.disabled"
                  :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @input="item.input?hanClick(item.input):null"
                  @focus="item.event?hanClick(item.event,item.value):null"
                  @keyup.enter.native="hanClick('sub')">
          <template slot="append" v-if="item.com">{{item.com}}</template>
        </el-input>
        <el-input v-if="item.type=='floatNum'"
                  v-model="formInfo.data[item.value]"
                  type="text"
                  oninput="value=value.replace(/[^\-\d.]/g,'')"
                  :remote="item.remote"
                  :remote-method="item.remote?remoteMethod:none"
                  :disabled="item.disabled"
                  :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @input="item.input?hanClick(item.input):null"
                  @focus="item.event?hanClick(item.event,item.value):null"
                  @keyup.enter.native="hanClick('sub')">
          <template slot="append" v-if="item.com">{{item.com}}</template>
        </el-input>
        <el-input v-if="item.type=='textNum'"
                  v-model="formInfo.data[item.value]"
                  type="text"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  :remote="item.remote"
                  :remote-method="item.remote?remoteMethod:none"
                  @change="selectChangeTtext"
                  :disabled="item.disabled"
                  :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @focus="item.event?hanClick(item.event,item.value):null"
                  @keyup.enter.native="hanClick('sub')">
          <template slot="prepend">{{tPrefixion}}</template>
        </el-input>
        <div v-else-if="item.type == 'slot'">
            <slot :name="'col-' + item.value" :value="item.value" />
        </div>
        <div v-else-if="item.type == 'textTwo'">
          <el-input v-model="formInfo.data[item.value1]"
                    type="text"
                    :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                    style="width:150px"
                    size="small"
                    :clearable="item.unclearable?false:true"
                    :readonly="item.readonly">
          </el-input>
          -
          <el-input v-model="formInfo.data[item.value2]"
                    type="text"
                    style="width:150px"
                    size="small"
                    :clearable="item.unclearable?false:true"
                    :readonly="item.readonly">
          </el-input>
        </div>
        <div v-else-if="item.type == 'textThree'">
          <el-input v-model="formInfo.data[item.value1]"
                    type="text"
                    :disabled="item.disabled"
                    placeholder="长"
                    style="width:90px"
                    size="small"
                    :clearable="item.unclearable?false:true"
                    @blur="item.blur?hanClick(item.blur):null">
          </el-input>-
          <el-input v-model="formInfo.data[item.value2]"
                    type="text"
                    :disabled="item.disabled"
                    placeholder="宽"
                    style="width:90px"
                    size="small"
                    :clearable="item.unclearable?false:true"
                    @blur="item.blur?hanClick(item.blur):null">
          </el-input>-
          <el-input v-model="formInfo.data[item.value3]"
                    type="text"
                    :disabled="item.disabled"
                    placeholder="高"
                    style="width:90px"
                    size="small"
                    :clearable="item.unclearable?false:true"
                    @blur="item.blur?hanClick(item.blur):null">
          </el-input>
        </div>
        <el-input v-if="item.type=='textMao'"
                  v-model="formInfo.data[item.value]"
                  type="text"
                  :remote="item.remote"
                  :remote-method="item.remote?remoteMethod:none"
                  @focus="item.remote?focus(item.value):''"
                  @change="selectChange"
                  :disabled="item.disabled"
                  :placeholder="0"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @keyup.enter.native="hanClick('sub')">
        </el-input>
        <el-input v-if="item.type=='textarea'"
                  v-model="formInfo.data[item.value]"
                  type="textarea"
                  autosize
                  :rows="item.rows?item.rows:2"
                  :disabled="item.disabled"
                  :placeholder="item.placeholder?item.placeholder:('请输入'+item.label.slice(0,item.label.length-1))"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @keyup.enter.native="hanClick('sub')">
        </el-input>
        <el-input v-else-if="item.type=='password'"
                  v-model="formInfo.data[item.value]"
                  type="password"
                  :disabled="item.disabled"
                  :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  @keyup.enter.native="hanClick('sub')">
        </el-input>
        <el-autocomplete v-else-if="item.type=='autocomplete'"
                         class="inline-input"
                         v-model="formInfo.data[item.value]"
                         :fetch-suggestions="querySearch"
                         @input="hanClick('autoinput')"
                         :placeholder="'请输入' + item.label.slice(0,item.label.length-1)"
                         @select="handleSelect">
        </el-autocomplete>
        <div v-else-if="item.type=='autocomplete1'"
             class="bgTextPar">
          <el-autocomplete class="inline-input"
                           v-model="formInfo.data[item.value]"
                           :remote="item.remote"
                           :remote-method="item.remote?remoteMethod:none"
                           @focus="item.remote?focus(item.value):''"
                           @change="selectChange"
                           :fetch-suggestions="querySearch"
                           @input="hanClick('autoinput')"
                           :placeholder="'请输入' + item.label.slice(0,item.label.length-1)"
                           @select="handleSelect">
          </el-autocomplete>
          <!-- <div class="WeighButton"
               @click="hanClick('formWeigh')">毛重</div> -->
        </div>
        <div v-else-if="item.type=='selectBtn'">
          <el-select 
                   v-model="formInfo.data[item.value]"
                   v-loading="item.vloading"
                   element-loading-spinner="el-icon-loading"
                   filterable
                   size="small"
                   :remote="item.remote"
                   :remote-method="item.remote?remoteMethod:none"
                   @focus="item.remote?focus(item.value):''"
                   @change="selectChange"
                   :loading="item.loading"
                   :disabled="item.disabled"
                   :style="item.style"
                   :placeholder="'请选择'+item.label.slice(0,item.label.length-1)+'，可输入过滤'"
                   :clearable="item.unclearable?false:true"
                   @keyup.enter.native="hanClick('sub')">
          <template slot="prefix" v-if="item.prefix">
            <i class="el-icon-search select_header" :size="item.size?item.size:'small'" @click.stop="selectHeaderClick(item.label)"></i>
          </template>
          <el-option v-for="item in listTypeInfo[item.list]"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
        <el-button size="small" icon="el-icon-plus" @click="hanClick('add')"></el-button>
        </div>
        <div v-else-if="item.type=='selectBtnSearch'">
          <el-select 
                   v-model="formInfo.data[item.value]"
                   v-loading="item.vloading"
                   element-loading-spinner="el-icon-loading"
                   filterable
                   size="small"
                   :remote="item.remote"
                   :remote-method="item.remote?remoteMethod:none"
                   @focus="item.remote?focus(item.value):''"
                   @change="selectChange"
                   :loading="item.loading"
                   :disabled="item.disabled"
                   :style="item.style"
                   :placeholder="'请选择'+item.label.slice(0,item.label.length-1)+'，可输入过滤'"
                   :clearable="item.unclearable?false:true"
                   @keyup.enter.native="hanClick('sub')">
          <template slot="prefix" v-if="item.prefix">
            <i class="el-icon-search select_header" :size="item.size?item.size:'small'" @click.stop="selectHeaderClick(item.label)"></i>
          </template>
          <el-option v-for="item in listTypeInfo[item.list]"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
        <el-button size="small" icon="el-icon-s-home" @click="hanClick('search')"></el-button>
        </div>
        <el-select v-else-if="item.type=='select'"
                   v-model="formInfo.data[item.value]"
                   v-loading="item.vloading"
                   element-loading-spinner="el-icon-loading"
                   filterable
                   size="small"
                   :remote="item.remote"
                   :remote-method="item.remote?remoteMethod:none"
                   @focus="item.remote?focus(item.value):''"
                   @change="selectChange"
                   :loading="item.loading"
                   :disabled="item.disabled"
                   :style="item.style"
                   :placeholder="'请选择'+item.label.slice(0,item.label.length-1)+'，可输入过滤'"
                   :clearable="item.unclearable?false:true"
                   @keyup.enter.native="hanClick('sub')">
          <template slot="prefix" v-if="item.prefix">
            <i class="el-icon-search select_header" :size="item.size?item.size:'small'" @click.stop="selectHeaderClick(item.label)"></i>
          </template>
          <el-option v-for="item in listTypeInfo[item.list]"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
        <el-select v-else-if="item.type=='selectTwo'"
                   v-model="formInfo.data[item.value]"
                   filterable
                   size="small"
                   :disabled="item.disabled"
                   :style="item.style"
                   :placeholder="'请选择'+item.label.slice(0,item.label.length-1)+'，可输入过滤'"
                   :clearable="item.unclearable?false:true">
          <el-option v-for="item in listTypeInfo[item.list]"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
        <el-radio-group v-model="formInfo.data[item.value]" v-else-if="item.type=='selectRadio'" @input="selectRadioInput(formInfo.data[item.value],'selectRadio',item.label)">
          <el-radio v-for="item in listTypeInfo[item.list]" :key="item.value" :label="item.value">{{item.label}}</el-radio>
        </el-radio-group>
        <el-checkbox v-model="formInfo.data[item.value]" :disabled="item.disabled" v-else-if="item.type=='checked'" @change="checkedChange2(formInfo.data[item.value],'selectChecked',item.label)">{{item.checkedName}}</el-checkbox>
        <el-select v-else-if="item.type=='selectTree'"
                   v-model="formInfo.data[item.value]"
                   :placeholder="'请选择'"
                   size="small"
                   :clearable="item.unclearable?false:true"
                   :style="item.selectStyle">
          <el-option :key="formInfo.data[item.value]"
                     :label="formInfo.data[item.label]"
                     :value="formInfo.data[item.value]"
                     style="height: auto;padding:0">
            <el-tree :data="listTypeInfo[item.list]"
                      :props="item.defaultProps"
                      node-key="id"
                      accordion
                      highlight-current
                      @node-click="handleNodeClick"
                      :style="item.style"
                      >
            </el-tree>
          </el-option>
        </el-select>
        <el-select v-else-if="item.type=='selectCreate'"
                   v-model="formInfo.data[item.value]"
                   v-loading="item.vloading"
                   element-loading-spinner="el-icon-loading"
                   allow-create
                   filterable
                   size="small"
                   :remote="item.remote"
                   v-show="item.flag != undefined?item.flag:true"
                   :remote-method="item.remote?remoteMethod:none"
                   @focus="item.remote?focus(item.value):''"
                   @change="selectChange($event,item.label)"
                   @blur="blurChange($event,item.label)"
                   @input="inputChange($event,item.label)"
                   :loading="item.loading"
                   :disabled="item.disabled"
                   :style="item.style"
                   :placeholder="item.placeholder?item.placeholder:'请选择'+item.label.slice(0,item.label.length-1)+'，可输入过滤'"
                   :clearable="item.unclearable?false:true"
                   @keyup.enter.native="hanClick('sub')">
          <template slot="prefix" v-if="item.prefix">
            <i class="el-icon-search select_header" :size="item.size?item.size:'small'" @click.stop="selectHeaderClick(item.label)"></i>
          </template>
          <el-option v-for="item in listTypeInfo[item.list]"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
        <el-select v-else-if="item.type=='selectMany'"
                   v-model="formInfo.data[item.value]"
                   multiple
                   filterable
                   size="small"
                   :remote="item.remote"
                   :remote-method="item.remote?remoteMethod:none"
                   @focus="item.remote?focus(item.value):''"
                   @change="selectChange"
                   :disabled="item.disabled"
                   :style="item.style"
                   :placeholder="'请选择'+item.label.slice(0,item.label.length-1)+'，可输入过滤'"
                   :clearable="item.unclearable?false:true">
          <template slot="prefix" v-if="item.prefix">
            <i class="el-icon-search select_header" :size="item.size?item.size:'small'" @click.stop="selectHeaderClick(item.label)"></i>
          </template>
          <el-option v-for="item in listTypeInfo[item.list]"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value"
                     :disabled="item.disabled">
          </el-option>
        </el-select>
        <el-date-picker v-else-if="item.type=='date'"
                        v-model="formInfo.data[item.value]"
                        size="small"
                        type="datetime"
                        :disabled="item.disabled"
                        :style="item.style"
                        :clearable="item.unclearable?false:true"
                        placeholder="选择日期时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @keyup.enter.native="hanClick('sub')">
        </el-date-picker>
        <el-date-picker v-else-if="item.type=='dateDay'"
                        v-model="formInfo.data[item.value]"
                        size="small"
                        type="date"
                        :disabled="item.disabled"
                        :style="item.style"
                        :clearable="item.unclearable?false:true"
                        :editable="item.editable?false:true"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                        @change="changeDate(item.value)"
                        @keyup.enter.native="hanClick('sub')">
        </el-date-picker>
        <el-time-picker v-else-if="item.type=='dateHou'"
                        v-model="formInfo.data[item.value]"
                        size="small"
                        :disabled="item.disabled"
                        :style="item.style"
                          value-format="HH:mm:ss"
                        :clearable="item.unclearable?false:true"
                        placeholder="选择时间">
        </el-time-picker>
        <div v-else-if="item.type == 'periodMonth'">
          <el-date-picker v-model="formInfo.data[item.value]"
                          :style="item.style"
                          size="small"
                          type="month"
                          value-format="yyyy-MM"
                          placeholder="选择年月"
                          :clearable="false">
          </el-date-picker>
        </div>
        <div v-else-if="item.type == 'period1'">
          <el-date-picker v-model="formInfo.data[item.value3]"
                          style="width:190px"
                          size="small"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :disabled="item.disabled"
                          placeholder="开始日期时间">
          </el-date-picker>
          -
          <el-date-picker v-model="formInfo.data[item.value4]"
                          style="width:190px"
                          size="small"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :disabled="item.disabled"
                          placeholder="结束日期时间">
          </el-date-picker>
        </div>
        <div v-else-if="item.type == 'period2'">
          <el-date-picker v-model="formInfo.data[item.value1]"
                          style="width:160px"
                          size="small"
                          type="date"
                          value-format="yyyy-MM-dd"
                          :disabled="item.disabled"
                          placeholder="开始日期">
          </el-date-picker>
          -
          <el-date-picker v-model="formInfo.data[item.value2]"
                          style="width:160px"
                          size="small"
                          type="date"
                          value-format="yyyy-MM-dd"
                          :disabled="item.disabled"
                          placeholder="结束日期">
          </el-date-picker>
        </div>
        <div v-else-if="item.type == 'period3'">
          <el-time-picker v-model="formInfo.data[item.value1]"
                          style="width:160px"
                          size="small"
                          value-format="HH:mm:ss"
                          :disabled="item.disabled"
                          placeholder="开始时间">
          </el-time-picker>
          -
          <el-time-picker v-model="formInfo.data[item.value2]"
                          style="width:160px"
                          size="small"
                          value-format="HH:mm:ss"
                          :disabled="item.disabled"
                          placeholder="结束时间">
          </el-time-picker>
        </div>
        <el-switch v-else-if="item.type=='switch'"
                   v-model="formInfo.data[item.value]"
                   :active-text="item.text1"
                   :inactive-text="item.text2"
                   :active-value="item.value1"
                   :inactive-value="item.value2">
        </el-switch>
        <BoyoUpload v-else-if="item.type=='upload'"
                    :action="action"
                    :src="formInfo.data[item.value]?addPrefixAndJoin(formInfo.data[item.value]):null"
                    :value="item.value"
                    :disabled="item.disabled"
                    :manual-select="!!item.manualSelect"
                    :external-loading="uploadLoading"
                    @on-success="handleAvatarSuccess"
                    @on-select-file="handleSelectFile"
                    @on-removeImg="handleRemove"
                    @uploading-change="handleUploadingChange"
                    @handlePictureCardPreview="handlePictureCardPreview">
        </BoyoUpload>
        <BoyoUpload v-else-if="item.type=='uploads'"
                    :action="action"
                    :src="formInfo.data[item.value]?addPrefixAndJoin(formInfo.data[item.value]):null"
                    :value="item.value"
                    :disabled="item.disabled"
                    :manual-select="!!item.manualSelect"
                    :external-loading="uploadLoading"
                    @on-success="handleAvatarSuccess"
                    @on-select-file="handleSelectFile"
                    @on-removeImg="handleRemove"
                    @uploading-change="handleUploadingChange"
                    @handlePictureCardPreview="handlePictureCardPreview">
        </BoyoUpload>
        <BoyoUploadThree v-else-if="item.type=='uploadThree'"
                       :action="actionFile"
                       :src="formInfo.data[item.value]?(imgUrl+formInfo.data[item.value]):null"
                       :value="item.value"
                       :disabled="item.disabled"
                       :fileListHt="item.fileListHt"
                       @on-success="handleAvatarSuccess"
                       @on-remove=" handleAvatarRemove">
        </BoyoUploadThree>
        <BoyoUploadtwo v-else-if="item.type=='uploadTwo'"
                       :action="action"
                       :src="formInfo.data[item.value]?(formInfo.data[item.value]):null"
                       :value="item.value"
                       :disabled="item.disabled"
                       :fileListHt="item.fileListHt"
                       @on-success="handleAvatarSuccess"
                       @on-remove="handleAvatarRemove"
                       @on-dialog="handleAvatarDialog">
        </BoyoUploadtwo>
        <BoyoUploadFour v-else-if="item.type=='uploadFour'"
                        :action="actionFile"
                        :src="formInfo.data[item.value]?(imgUrl+formInfo.data[item.value]):null"
                        :value="item.value"
                        :disabled="item.disabled"
                        :fileListHt="item.fileListHt"
                        @on-success="handleAvatarSuccess"
                        @on-remove="handleAvatarRemove"
                        @on-dialog="handleAvatarDialog">
        </BoyoUploadFour>
        <div class="bgTextPar"
             v-else-if="item.type=='bgText'">
          <div class="bgText">{{formInfo.data[item.value]}}</div>
          <div class="bgText bgDes">Kg</div>
          <div class="bgTextButton"
               @click="hanClick('formRefresh')">刷新</div>
        </div>
        <div class="bgTextPar"
             v-else-if="item.type=='bgTextTwo'">
          <div class="bgText">{{formInfo.data[item.value]}}</div>
          <div class="bgText bgDes">吨</div>
          <!-- <div class="bgTextButton"
               @click="hanClick('formRefresh')">刷新</div> -->
        </div>
        <!-- <el-checkbox v-else-if="item.type=='checked'"
                     v-model="checked"
                     @change="checkedChange"></el-checkbox> -->
        <!-- <div v-else-if="item.type=='checked'">
          <el-select v-model="formInfo.data[item.value]"
                     v-loading="item.vloading"
                     element-loading-spinner="el-icon-loading"
                     filterable
                     size="small"
                     :remote="item.remote"
                     :remote-method="item.remote?remoteMethod:none"
                     @focus="item.remote?focus(item.value):''"
                     @change="selectChange"
                     :loading="item.loading"
                     :disabled="item.disabled"
                     :style="item.style"
                     :placeholder="'请选择'+item.label.slice(0,item.label.length-1)"
                     :clearable="item.unclearable?false:true"
                     @keyup.enter.native="hanClick('sub')">
            <el-option v-for="item in listTypeInfo[item.list]"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-checkbox v-model="checked"
                       @change="checkedChange"></el-checkbox>
        </div> -->
        <!-- <div v-else-if="item.type=='xuanze'">
          <input type="text"
                 class="carno">
          <div class="jianc"
               @click="open">省份简称</div>
        </div> -->
        <div v-else-if="item.type=='showDes'"
             v-show="formInfo.showDes"
             class="showDes">
          <div class="showDesMargin">
            商品信息:
          </div>
          <div>
            <div v-show="formInfo.desDate.goodsSpec">规格1：{{formInfo.desDate.goodsSpec}}</div>
            <div v-show="formInfo.desDate.goodsSpec2">规格2：{{formInfo.desDate.goodsSpec2}}</div>
            <div v-show="formInfo.desDate.model1">型号1：{{formInfo.desDate.model1}}</div>
            <div v-show="formInfo.desDate.model2">型号2：{{formInfo.desDate.model2}}</div>
          </div>
        </div>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
import config from '@/api/config'
import BoyoUpload from '@/components/BoyoUpload'
import BoyoUploadtwo from '@/components/BoyoUploadtwo'
import BoyoUploadThree from '@/components/BoyoUploadThree'
import BoyoUploadFour from '@/components/BoyoUploadFour'

export default {
  name: 'BoyoForm',
  components: {
    BoyoUpload,
    BoyoUploadtwo,BoyoUploadThree,BoyoUploadFour
  },
  props: {
    formInfo: Object,
    refObj: Object,
    listTypeInfo: Object,
    /** 父页面异步上传中时传入，与组件内 loading 联动 */
    uploadLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      checked: false,
      imgUrl: config.pingImgUrl,
      event: '', // 配合select的远程搜索事件
      action: config.upload,
      actionFile: config.uploadFile,
      tPrefixion:localStorage.tPrefixion?localStorage.tPrefixion:'',
    }
  },
  watch: {
    'formInfo.data' (val) {
      this.$emit('update:refObj', this.$refs.form)
    }
  },
  mounted () {
    this.action = config.upload
    this.actionFile = config.uploadFile
    // 将form实例返回到父级
    this.$emit('update:refObj', this.$refs.form)
  },
  methods: {
    formatAmount(cellValue) {
      if (typeof cellValue == 'number') {
        cellValue = Number(cellValue.toFixed(2))
        return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }else{
          return cellValue
      }
    },
    // 选择上传事件
    // handlePictureCardPreview (file) {
    //   this.dialogImageUrl = file.url;
    //   this.dialogVisible = true;
    // },
    // handleDownload (file) {
    //   console.log(file);
    // },
    // beforeAvatarUpload (file) {
    //   const isLt2M = file.size / 1024 / 1024 < 10;
    //   if (!isLt2M) {
    //     this.$message.error('上传头像图片大小不能超过 10MB!');
    //   }
    //   return isLt2M;
    // },
    // 选择输入框选择事件
    handleSelect (item) {
      this.$emit('handleSelect', item)
    },
    // 选择输入框输入事件
    querySearch (queryString, cb) {
      this.$emit('querySearch', queryString, cb)
    },
    hanClick (event,value) {
      this.$emit('hanClick', event,value)
    },
    handleNodeClick (node) {
      this.$emit('handleNodeClick', node)
    },
    focus (val) {
      this.event = val
    },
    remoteMethod (query) {
      // console.log(query)
      // if (query) {
        this.$emit('formremoteMethod', this.event, query, 'remoteMethod')
      // }
    },
    selectRadioInput (query,event,label) {
      // console.log(query)
      this.$emit('formremoteMethod',event, query, 'selectRadio' + label)
    },
    checkedChange2 (query,event,label) {
      // console.log(query)
      this.$emit('formremoteMethod',event, query, 'selectChecked' + label)
    },
    none () {

    },
    selectHeaderClick(label){
      this.$emit('selectHeaderClick', label)
    },
    selectChange (val) {
      this.$emit('formremoteMethod', this.event, val, 'select')
      // this.$emit('formremoteMethod', this.event, val, '')
    },
    selectChangeTtext (val) {
      this.$emit('formremoteMethod', this.event, val, 'text')
    },
    changeDate (name) { // 日期选择发生变化事件
      this.$emit('changeDate',name)
    },
    checkedChange (event) {
      this.$emit('checkedChange', event)
    },
    handleAvatarSuccess (res, file, fileList, value) {
      this.$emit('on-success', res, file, fileList, value)
    },
    handleSelectFile (file, value) {
      this.$emit('on-select-file', file, value)
    },
    handleUploadingChange (uploading) {
      this.$emit('uploading-change', uploading)
    },
    handleAvatarRemove (file, fileList, value) {
      this.$emit('on-remove', file, fileList, value)
    },
    handleAvatarDialog ( value) {
      this.$emit('on-dialog', value)
    },
    handlePictureCardPreview (url, value) {
      this.$emit('handlePictureCardPreview', url, value)
    },
    handleRemove (value) {
      if(value){
        this.formInfo.data[value] = ''
      }
    },
    addPrefixAndJoin(str) {
        // 分割字符串
        const parts = str.split(',');
        // 遍历数组，检查并修改每个元素
        const processedParts = parts.map(part => {
            // 检查是否包含前缀，如果不包含则添加
            if (!part.startsWith(this.imgUrl)) {
                return this.imgUrl + part;
            }
            return part;
        });
        // 重新拼接字符串
        return processedParts.join(',');
    }
  }
}
</script>
<style lang="stylus" scoped>
.form >>>.el-loading-spinner
  padding-right 2px
  box-sizing border-box
  text-align right
  .circular
    height 25px
    width 25px
.form_item_one
  width 100%
  margin-right 0
  text-align left
.form_item_one>>> .el-form-item__content
  width 87.5%
.form_item_new
  width 100%
  margin-right 0
  text-align left
.form_item_new>>> .el-form-item__content
  width 70%
.form_item_two
  width 50%
  margin-right 0
  text-align left
.form_item_two>>> .el-form-item__content
  width 75%
.bgTextPar
  display flex
  flex-direction row
.bgText
  color red
  width 250px
  height 100px
  line-height 100px
  background-color #000
  color #fff
  font-size 70px
  text-align center
.xuanzePar
  display flex
  flex-direction row
.bgDes
  width 120px
  padding-right 20px
.bgTextButton
  margin-left 20px
  background-color #409EFF
  height 50px
  margin-top 25px
  width 70px
  color #ffffff
  text-align center
  line-height 50px
  border-radius 5px
  cursor pointer
.WeighButton
  background-color #409EFF
  height 30px
  margin 5px 0 0 20px
  width 60px
  color #ffffff
  text-align center
  line-height 30px
  border-radius 2px
  cursor pointer
.showDes
  display flex
  flex-direction row
.showDesMargin
  margin-right 20px
.carno
  height 28px
  width 70%
  // border-radius 2px
.jianc
  // margin-left 80%
  float right
  background-color #409EFF
  height 40px
  margin-right 10%
  width 70px
  color #ffffff
  text-align center
  line-height 40px
  cursor pointer
.select_header
  color #606266
  font-size 18px
  margin-top 10px
</style>



// WEBPACK FOOTER //
// src/components/BoyoForm/index.vue